<button data-cy="floating-upload-button__floating-upload-btn" mat-fab class="floating-upload-btn" matTooltip="Upload picture" (click)="triggerFileInput()">
    <i class="uil uil-camera"></i>
</button>

<input data-cy="floating-upload-button__file-input"
  #fileInput
  type="file"
  id="fileInput"
  accept="image/*;capture=camera"
  (change)="onFileSelected($event)"
/>
